import React, { FC, useId } from "react";
import { useTranslation } from "react-i18next";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

export interface InfoTooltipProps {
    i18nKey: string;
    className?: string;
}

const InfoTooltip: FC<InfoTooltipProps> = ({ i18nKey, className = "" }) => {
    const { t } = useTranslation("translation");
    const tooltipId = useId();

    return (
        <span className={`relative inline-flex items-center ${className}`}>
            <span className="group relative inline-flex">
                <InformationCircleIcon
                    className="w-4 h-4 text-neutral-400 hover:text-neutral-700 dark:hover:text-neutral-200 cursor-help"
                    aria-describedby={tooltipId}
                />
                <span
                    id={tooltipId}
                    role="tooltip"
                    className="pointer-events-none absolute z-50 bottom-full left-1/2 mb-2 w-72 -translate-x-1/2 rounded-lg bg-neutral-900 px-3 py-2 text-xs text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
                >
                    {t(i18nKey)}
                </span>
            </span>
        </span>
    );
};

export default InfoTooltip;
